import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, vModelRadio as _vModelRadio, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_2 = {
  class: "data-table-shell"
};
const _hoisted_3 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_4 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_5 = {
  class: "data-table-head"
};
const _hoisted_6 = {
  class: "data-table-th is-center w-10"
};
const _hoisted_7 = {
  class: "data-table-body"
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "data-table-td is-center"
};
const _hoisted_10 = ["onUpdate:modelValue"];
const _hoisted_11 = {
  class: "data-table-td"
};
const _hoisted_12 = {
  class: "data-table-td"
};
const _hoisted_13 = {
  class: "data-table-td"
};
const _hoisted_14 = {
  class: "data-table-td"
};
const _hoisted_15 = {
  class: "data-table-td is-center"
};
const _hoisted_16 = {
  class: "data-table-td"
};
const _hoisted_17 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_18 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_22 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_23 = {
  class: "p-6 overflow-y-auto max-h-[calc(90vh-140px)]"
};
const _hoisted_24 = {
  class: "space-y-4"
};
const _hoisted_25 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_26 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_27 = {
  class: "flex items-center justify-between mb-2"
};
const _hoisted_28 = {
  class: "flex items-center gap-2 cursor-pointer"
};
const _hoisted_29 = {
  class: "border border-slate-300 rounded-lg p-4 bg-slate-50 max-h-60 overflow-y-auto"
};
const _hoisted_30 = {
  class: "space-y-1"
};
const _hoisted_31 = {
  key: 0,
  class: "text-sm text-slate-500"
};
const _hoisted_32 = ["onClick"];
const _hoisted_33 = {
  key: 1,
  class: "w-4 h-4"
};
const _hoisted_34 = {
  class: "flex items-center gap-2 cursor-pointer"
};
const _hoisted_35 = ["checked", ".indeterminate", "onChange"];
const _hoisted_36 = {
  class: "text-sm text-slate-700"
};
const _hoisted_37 = {
  key: 0,
  class: "border border-slate-300 rounded-lg p-8 text-center text-sm text-slate-500"
};
const _hoisted_38 = {
  key: 1,
  class: "border border-slate-300 rounded-lg p-8 text-center text-sm text-slate-500"
};
const _hoisted_39 = {
  key: 2,
  class: "border border-slate-300 rounded-lg overflow-hidden"
};
const _hoisted_40 = {
  class: "overflow-x-auto max-h-96 overflow-y-auto"
};
const _hoisted_41 = {
  class: "w-full"
};
const _hoisted_42 = {
  class: "bg-white divide-y divide-slate-200"
};
const _hoisted_43 = {
  class: "hover:bg-slate-50 transition-colors"
};
const _hoisted_44 = {
  class: "px-4 py-3"
};
const _hoisted_45 = {
  class: "flex flex-col"
};
const _hoisted_46 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_47 = {
  class: "text-xs text-slate-500 font-mono"
};
const _hoisted_48 = {
  class: "px-4 py-3 text-center"
};
const _hoisted_49 = {
  class: "inline-flex items-center justify-center cursor-pointer"
};
const _hoisted_50 = ["name", "onUpdate:modelValue", "onChange"];
const _hoisted_51 = {
  class: "px-4 py-3 text-center"
};
const _hoisted_52 = {
  class: "inline-flex items-center justify-center cursor-pointer"
};
const _hoisted_53 = ["name", "onUpdate:modelValue", "onChange"];
const _hoisted_54 = {
  class: "px-4 py-3 text-center"
};
const _hoisted_55 = {
  class: "inline-flex items-center justify-center cursor-pointer"
};
const _hoisted_56 = ["name", "onUpdate:modelValue", "onChange"];
const _hoisted_57 = {
  class: "px-4 py-3 text-center"
};
const _hoisted_58 = {
  class: "inline-flex items-center justify-center cursor-pointer"
};
const _hoisted_59 = ["name", "onUpdate:modelValue", "onChange"];
const _hoisted_60 = {
  class: "px-4 py-3 text-center"
};
const _hoisted_61 = {
  class: "inline-flex items-center justify-center cursor-pointer"
};
const _hoisted_62 = ["name", "onUpdate:modelValue", "onChange"];
const _hoisted_63 = {
  key: 0,
  class: "bg-slate-50"
};
const _hoisted_64 = {
  colspan: "6",
  class: "px-4 py-3"
};
const _hoisted_65 = {
  class: "flex items-center gap-2"
};
const _hoisted_66 = {
  class: "p-6 text-center"
};
const _hoisted_67 = {
  class: "text-sm text-slate-500 mb-6"
};
const _hoisted_68 = {
  class: "p-6 overflow-y-auto max-h-[calc(90vh-140px)]"
};
const _hoisted_69 = {
  class: "mb-4"
};
const _hoisted_70 = {
  class: "border border-slate-200 rounded-lg overflow-hidden"
};
const _hoisted_71 = {
  class: "w-full"
};
const _hoisted_72 = {
  class: "divide-y divide-slate-200"
};
const _hoisted_73 = {
  key: 0
};
const _hoisted_74 = {
  key: 1
};
const _hoisted_75 = {
  class: "px-4 py-3 text-sm text-slate-900 font-mono"
};
const _hoisted_76 = {
  class: "px-4 py-3 text-sm text-slate-900"
};
const _hoisted_77 = {
  class: "px-4 py-3 text-sm text-slate-600 font-mono"
};
const _hoisted_78 = {
  class: "px-4 py-3 text-sm text-slate-600 font-mono"
};
const _hoisted_79 = {
  class: "px-4 py-3 text-sm text-slate-600"
};
const _hoisted_80 = {
  class: "px-4 py-3"
};
const _hoisted_81 = {
  class: "px-4 py-3"
};
const _hoisted_82 = {
  class: "flex items-center gap-1"
};
const _hoisted_83 = ["onClick"];
const _hoisted_84 = ["onClick"];
const _hoisted_85 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_86 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_87 = {
  class: "p-6 overflow-y-auto max-h-[calc(90vh-140px)]"
};
const _hoisted_88 = {
  class: "space-y-4"
};
const _hoisted_89 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_90 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_91 = {
  class: "grid grid-cols-2 gap-4"
};
import { ref, computed, reactive, onMounted, watch } from 'vue';
import AppPagination from '@/components/AppPagination.vue';
import DeptSelector from '@/components/DeptSelector/index.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getRoles, getRole, createRole, updateRole, deleteRole, getAllDataScopeResources, saveDataScopeResource, deleteDataScopeResource } from '@/api/role';
import { getMenuTree } from '@/api/menu';
import { getDeptTree } from '@/api/dept';
import PageFilterBar from '@/components/PageFilterBar.vue';
import AppModal from '@/components/AppModal.vue';

// 搜索表单
const STATUS_ENABLED = 0;
const STATUS_DISABLED = 1;
export default {
  __name: 'RoleManagement',
  setup(__props) {
    const dataScopeOptions = [{
      value: 1,
      label: '全部'
    }, {
      value: 2,
      label: '本部门'
    }, {
      value: 3,
      label: '本部门及以下'
    }, {
      value: 4,
      label: '自定义'
    }];
    const searchForm = reactive({
      name: '',
      roleKey: '',
      status: ''
    });
    const roleList = ref([]);
    const loading = ref(false);

    // 分页
    const pageNum = ref(1);
    const pageSize = ref(10);
    const total = computed(() => roleList.value.length);
    const totalPage = computed(() => Math.max(1, Math.ceil(total.value / pageSize.value)));
    const displayedRoles = computed(() => {
      const start = (pageNum.value - 1) * pageSize.value;
      return roleList.value.slice(start, start + pageSize.value);
    });

    // 分页处理
    const handlePageChange = p => {
      pageNum.value = p;
    };
    const handlePageSizeChange = s => {
      pageSize.value = s;
      pageNum.value = 1;
    };

    // 扁平化菜单树（用于显示）
    const flattenedMenuTree = computed(() => {
      const result = [];
      const traverse = (nodes, level) => {
        if (!Array.isArray(nodes)) return;
        nodes.forEach(node => {
          result.push({
            node,
            level
          });
          if (node.children && Array.isArray(node.children) && expandedMenuIds.value.includes(node.id)) {
            traverse(node.children, level + 1);
          }
        });
      };
      if (Array.isArray(menuTree.value)) {
        traverse(menuTree.value, 0);
      }
      return result;
    });

    // 全选
    const selectAll = ref(false);
    const toggleSelectAll = () => {
      roleList.value.forEach(role => {
        role.selected = selectAll.value;
      });
    };

    // 弹窗相关
    const modalVisible = ref(false);
    const modalType = ref('add');
    const currentRole = ref(null);

    // 表单数据
    const form = reactive({
      name: '',
      roleKey: '',
      dataScope: 1,
      status: STATUS_ENABLED
    });

    // 菜单权限
    const menuTree = ref([]);
    const expandedMenuIds = ref([]);
    const selectedMenuIds = ref([]); // 完全选中的节点
    const halfSelectedMenuIds = ref([]); // 半选中的节点（部分子节点选中）
    const menuTreeLoaded = ref(false);
    const menuCascade = ref(false); // 父子联动开关

    // 检查节点是否有子节点被选中
    const hasChildSelected = node => {
      if (selectedMenuIds.value.includes(node.id)) return true;
      if (halfSelectedMenuIds.value.includes(node.id)) return true;
      if (node.children && Array.isArray(node.children) && node.children.length > 0) {
        return node.children.some(child => hasChildSelected(child));
      }
      return false;
    };

    // 更新单个节点的选中状态
    const updateNodeState = node => {
      if (!node.children || !Array.isArray(node.children) || node.children.length === 0) {
        return;
      }
      const checkedChildren = node.children.filter(child => selectedMenuIds.value.includes(child.id));
      const allChildren = node.children.filter(child => hasChildSelected(child));
      if (checkedChildren.length === node.children.length) {
        // 所有子节点都选中，移除半选状态，设置为完全选中
        halfSelectedMenuIds.value = halfSelectedMenuIds.value.filter(id => id !== node.id);
        if (!selectedMenuIds.value.includes(node.id)) {
          selectedMenuIds.value.push(node.id);
        }
      } else if (allChildren.length > 0) {
        // 部分子节点选中，添加半选状态
        if (!halfSelectedMenuIds.value.includes(node.id)) {
          halfSelectedMenuIds.value.push(node.id);
        }
        selectedMenuIds.value = selectedMenuIds.value.filter(id => id !== node.id);
      } else {
        // 没有子节点选中，移除选中状态
        selectedMenuIds.value = selectedMenuIds.value.filter(id => id !== node.id);
        halfSelectedMenuIds.value = halfSelectedMenuIds.value.filter(id => id !== node.id);
      }
    };

    // 更新所有父节点的选中状态（从叶子到根的递归顺序）
    const updateParentStates = () => {
      // 递归更新，先更新子节点再更新父节点
      const updateRecursively = nodes => {
        if (!Array.isArray(nodes)) return;
        for (const node of nodes) {
          if (node.children && Array.isArray(node.children)) {
            // 先递归更新所有子节点
            updateRecursively(node.children);
            // 再更新当前节点
            updateNodeState(node);
          }
        }
      };
      updateRecursively(menuTree.value);
    };

    // 查找从根到目标节点的祖先路径
    const findNodeAncestors = targetId => {
      const ancestors = [];
      const find = (nodes, path) => {
        if (!Array.isArray(nodes)) return false;
        for (const node of nodes) {
          if (node.id === targetId) {
            ancestors.push(...path);
            return true;
          }
          if (node.children && Array.isArray(node.children)) {
            if (find(node.children, [...path, node])) {
              return true;
            }
          }
        }
        return false;
      };
      find(menuTree.value, []);
      return ancestors;
    };

    // 只更新当前操作节点的祖先链状态（不影响其他分支）
    const updateAncestorStates = targetId => {
      const ancestors = findNodeAncestors(targetId);
      // 从最近的父节点向上逐层更新
      for (let i = ancestors.length - 1; i >= 0; i--) {
        updateNodeState(ancestors[i]);
      }
    };

    // 检查节点是否被选中（包括完全选中或半选中）
    const isNodeChecked = node => {
      return selectedMenuIds.value.includes(node.id) || halfSelectedMenuIds.value.includes(node.id);
    };

    // 检查节点是否处于半选状态（部分子节点选中）
    const isNodeIndeterminate = node => {
      return halfSelectedMenuIds.value.includes(node.id);
    };

    // 检查节点是否展开
    const isExpanded = menuId => expandedMenuIds.value.includes(menuId);

    // 切换节点展开/收起
    const toggleExpand = menuId => {
      if (expandedMenuIds.value.includes(menuId)) {
        expandedMenuIds.value = expandedMenuIds.value.filter(id => id !== menuId);
      } else {
        expandedMenuIds.value = [...expandedMenuIds.value, menuId];
      }
    };

    // 设置节点选中状态（联动模式）
    const setNodeCheckedCascade = (node, checked) => {
      if (checked) {
        // 选中当前节点
        if (!selectedMenuIds.value.includes(node.id)) {
          selectedMenuIds.value.push(node.id);
        }
        // 移除半选状态
        halfSelectedMenuIds.value = halfSelectedMenuIds.value.filter(id => id !== node.id);

        // 选中所有子节点
        if (node.children && Array.isArray(node.children) && node.children.length > 0) {
          const selectAllChildren = children => {
            if (!Array.isArray(children)) return;
            children.forEach(child => {
              if (!selectedMenuIds.value.includes(child.id)) {
                selectedMenuIds.value.push(child.id);
              }
              halfSelectedMenuIds.value = halfSelectedMenuIds.value.filter(id => id !== child.id);
              if (child.children && Array.isArray(child.children) && child.children.length > 0) {
                selectAllChildren(child.children);
              }
            });
          };
          selectAllChildren(node.children);
        }
      } else {
        // 取消选中当前节点
        selectedMenuIds.value = selectedMenuIds.value.filter(id => id !== node.id);
        halfSelectedMenuIds.value = halfSelectedMenuIds.value.filter(id => id !== node.id);

        // 取消选中所有子节点
        if (node.children && Array.isArray(node.children) && node.children.length > 0) {
          const unselectAllChildren = children => {
            if (!Array.isArray(children)) return;
            children.forEach(child => {
              selectedMenuIds.value = selectedMenuIds.value.filter(id => id !== child.id);
              halfSelectedMenuIds.value = halfSelectedMenuIds.value.filter(id => id !== child.id);
              if (child.children && Array.isArray(child.children) && child.children.length > 0) {
                unselectAllChildren(child.children);
              }
            });
          };
          unselectAllChildren(node.children);
        }
      }

      // 只更新当前操作节点的祖先链，不影响其他分支
      updateAncestorStates(node.id);
    };
    const onNodeCheck = (node, event) => {
      const checked = event.target.checked;
      if (menuCascade.value) {
        // 父子联动模式
        setNodeCheckedCascade(node, checked);
      } else {
        // 非联动模式：只影响当前节点
        const selected = new Set(selectedMenuIds.value);
        const halfSelected = new Set(halfSelectedMenuIds.value);
        if (checked) {
          selected.add(node.id);
          halfSelected.delete(node.id);
        } else {
          selected.delete(node.id);
          halfSelected.delete(node.id);
        }
        selectedMenuIds.value = Array.from(selected);
        halfSelectedMenuIds.value = Array.from(halfSelected);
      }
    };
    const resetMenuSelection = () => {
      selectedMenuIds.value = [];
      halfSelectedMenuIds.value = [];
    };
    const applyMenuSelection = (menuIds = []) => {
      const menuIdSet = new Set(menuIds);
      selectedMenuIds.value = [];
      halfSelectedMenuIds.value = [];

      // 选中 menuIds 中存在的节点
      const traverse = item => {
        if (menuIdSet.has(item.id) && Number.isFinite(item.id)) {
          selectedMenuIds.value.push(item.id);
        }
        if (item.children && Array.isArray(item.children) && item.children.length > 0) {
          item.children.forEach(traverse);
        }
      };
      if (Array.isArray(menuTree.value)) {
        menuTree.value.forEach(traverse);
      }

      // 父子联动开启时才根据子节点反推父级半选状态；默认关闭时严格回显后端返回的权限。
      if (menuCascade.value) {
        updateParentStates();
      }
    };
    const collectCheckedMenuIds = () => {
      // 返回完全选中 + 半选中的所有节点ID
      const allSelected = new Set([...selectedMenuIds.value, ...halfSelectedMenuIds.value]);
      return Array.from(allSelected);
    };
    const collectExpandedIds = nodes => {
      const ids = [];
      if (!Array.isArray(nodes)) return ids;
      nodes.forEach(node => {
        if (node.children && Array.isArray(node.children) && node.children.length > 0 && Number.isFinite(node.id)) {
          ids.push(node.id);
          ids.push(...collectExpandedIds(node.children));
        }
      });
      return ids;
    };
    const fetchMenuTree = async () => {
      if (menuTreeLoaded.value) return;
      try {
        const data = await getMenuTree();
        menuTree.value = Array.isArray(data) ? data : [];
        expandedMenuIds.value = collectExpandedIds(menuTree.value);
        menuTreeLoaded.value = true;
      } catch (error) {
        ElMessage.error(error.message || '获取菜单树失败');
      }
    };

    // 打开弹窗
    const openModal = async (type, role) => {
      modalType.value = type;
      modalVisible.value = true;

      // 编辑时重新获取最新的菜单树
      if (type === 'edit') {
        menuTreeLoaded.value = false;
      }
      await fetchMenuTree();
      if (type === 'add') {
        form.name = '';
        form.roleKey = '';
        form.dataScope = 1;
        form.status = STATUS_ENABLED;
        resetMenuSelection();
        // 加载资源权限配置（新增时使用默认值）
        await loadRoleResourceScopes(null);
      } else if (type === 'edit' && role) {
        currentRole.value = role;
        try {
          const detail = await getRole(role.id);
          form.name = detail?.name || role.name;
          form.roleKey = detail?.roleKey || role.roleKey;
          form.dataScope = detail?.dataScope ?? role.dataScope ?? 1;
          form.status = detail?.status ?? role.status ?? STATUS_ENABLED;
          applyMenuSelection(detail?.menuIds || []);
          // 加载资源权限配置（编辑时加载角色的资源配置）
          await loadRoleResourceScopes(role.id);
        } catch (error) {
          form.name = role.name;
          form.roleKey = role.roleKey;
          form.dataScope = role.dataScope ?? 1;
          form.status = role.status ?? STATUS_ENABLED;
          applyMenuSelection(role.menuIds || []);
          await loadRoleResourceScopes(role.id);
          ElMessage.error(error.message || '获取角色详情失败');
        }
      }
    };

    // 关闭弹窗
    const closeModal = () => {
      modalVisible.value = false;
      currentRole.value = null;
    };

    // 保存角色
    const saveRole = async () => {
      if (!form.name.trim()) {
        ElMessage.warning('请输入角色名称');
        return;
      }
      if (!form.roleKey.trim()) {
        ElMessage.warning('请输入权限字符');
        return;
      }

      // 构建资源数据权限配置
      const resourceDataScopes = roleResourceScopes.value.map(resource => ({
        resourceCode: resource.resourceCode,
        dataScope: resource.dataScope,
        deptIds: resource.dataScope === 5 ? (resource.deptSelection || []).map(d => typeof d === 'object' ? d.id : d) : []
      }));
      const payload = {
        name: form.name.trim(),
        roleKey: form.roleKey.trim(),
        dataScope: form.dataScope,
        status: Number(form.status),
        menuIds: collectCheckedMenuIds(),
        resourceDataScopes: resourceDataScopes
      };
      try {
        if (modalType.value === 'add') {
          await createRole(payload);
          ElMessage.success('新增成功');
        } else if (currentRole.value) {
          await updateRole(currentRole.value.id, {
            id: currentRole.value.id,
            ...payload
          });
          ElMessage.success('修改成功');
        }
        await fetchRoles();
        closeModal();
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
      }
    };

    // 搜索
    const handleSearch = async () => {
      pageNum.value = 1;
      await fetchRoles();
    };

    // 重置搜索
    const resetSearch = async () => {
      searchForm.name = '';
      searchForm.roleKey = '';
      searchForm.status = '';
      pageNum.value = 1;
      await fetchRoles();
    };

    // 单个删除
    const handleDeleteSingle = role => {
      openDeleteModal([role]);
    };
    const showDeleteModal = ref(false);
    const pendingDeleteRoles = ref([]);
    const deleteHint = computed(() => {
      if (pendingDeleteRoles.value.length === 1) {
        return `将删除角色 "${pendingDeleteRoles.value[0].name}"，删除后无法恢复。`;
      }
      return `将删除 ${pendingDeleteRoles.value.length} 个角色，删除后无法恢复。`;
    });
    const openDeleteModal = roles => {
      pendingDeleteRoles.value = roles;
      showDeleteModal.value = true;
    };
    const closeDeleteModal = () => {
      showDeleteModal.value = false;
      pendingDeleteRoles.value = [];
    };
    const confirmDelete = async () => {
      const ids = pendingDeleteRoles.value.map(role => role.id);
      if (ids.length === 0) {
        closeDeleteModal();
        return;
      }
      try {
        await Promise.all(ids.map(id => deleteRole(id)));
        ElMessage.success('删除成功');
        await fetchRoles();
      } catch (error) {
        ElMessage.error(error.message || '删除失败');
      } finally {
        closeDeleteModal();
      }
    };
    const formatDataScope = value => {
      const option = dataScopeOptions.find(item => item.value === value);
      return option ? option.label : '-';
    };
    const fetchRoles = async () => {
      loading.value = true;
      const params = {
        name: searchForm.name.trim(),
        roleKey: searchForm.roleKey.trim()
      };
      if (searchForm.status !== '') {
        params.status = Number(searchForm.status);
      }
      try {
        const data = await getRoles(params);
        const list = Array.isArray(data) ? data : [];
        roleList.value = list.map(role => ({
          ...role,
          selected: false
        }));
        selectAll.value = false;
      } catch (error) {
        ElMessage.error(error.message || '获取角色列表失败');
      } finally {
        loading.value = false;
      }
    };
    watch([total, pageSize], () => {
      if (pageNum.value > totalPage.value) {
        pageNum.value = totalPage.value;
      }
    });
    watch(pageSize, () => {
      pageNum.value = 1;
    });

    // 权限配置相关
    const permissionConfigVisible = ref(false);
    const resourcesList = ref([]);
    const resourcesLoading = ref(false);

    // 资源表单弹窗
    const resourceModalVisible = ref(false);
    const resourceModalType = ref('add');
    const currentResource = ref(null);
    const resourceForm = reactive({
      resourceCode: '',
      resourceName: '',
      deptColumn: '',
      userColumn: '',
      description: '',
      sort: 0,
      status: STATUS_ENABLED
    });

    // 打开权限配置弹窗
    const openPermissionConfigModal = async () => {
      permissionConfigVisible.value = true;
      await fetchResourcesList();
    };

    // 关闭权限配置弹窗
    const closePermissionConfigModal = () => {
      permissionConfigVisible.value = false;
    };

    // 获取资源列表
    const fetchResourcesList = async () => {
      resourcesLoading.value = true;
      try {
        const data = await getAllDataScopeResources();
        resourcesList.value = Array.isArray(data) ? data : [];
      } catch (error) {
        ElMessage.error(error.message || '获取资源列表失败');
      } finally {
        resourcesLoading.value = false;
      }
    };

    // 打开资源表单弹窗
    const openResourceModal = (type, resource) => {
      resourceModalType.value = type;
      resourceModalVisible.value = true;
      if (type === 'add') {
        resourceForm.resourceCode = '';
        resourceForm.resourceName = '';
        resourceForm.deptColumn = '';
        resourceForm.userColumn = '';
        resourceForm.description = '';
        resourceForm.sort = 0;
        resourceForm.status = STATUS_ENABLED;
        currentResource.value = null;
      } else if (type === 'edit' && resource) {
        currentResource.value = resource;
        resourceForm.resourceCode = resource.resourceCode || '';
        resourceForm.resourceName = resource.resourceName || '';
        resourceForm.deptColumn = resource.deptColumn || '';
        resourceForm.userColumn = resource.userColumn || '';
        resourceForm.description = resource.description || '';
        resourceForm.sort = resource.sort || 0;
        resourceForm.status = resource.status ?? STATUS_ENABLED;
      }
    };

    // 关闭资源表单弹窗
    const closeResourceModal = () => {
      resourceModalVisible.value = false;
      currentResource.value = null;
    };

    // 保存资源
    const saveResource = async () => {
      if (!resourceForm.resourceCode.trim()) {
        ElMessage.warning('请输入资源编码');
        return;
      }
      if (!resourceForm.resourceName.trim()) {
        ElMessage.warning('请输入资源名称');
        return;
      }
      const payload = {
        resourceCode: resourceForm.resourceCode.trim(),
        resourceName: resourceForm.resourceName.trim(),
        deptColumn: resourceForm.deptColumn.trim(),
        userColumn: resourceForm.userColumn.trim(),
        description: resourceForm.description.trim(),
        sort: Number(resourceForm.sort) || 0,
        status: Number(resourceForm.status)
      };

      // 如果是编辑模式，添加 ID
      if (resourceModalType.value === 'edit' && currentResource.value) {
        payload.id = currentResource.value.id;
      }
      try {
        await saveDataScopeResource(payload);
        ElMessage.success(resourceModalType.value === 'add' ? '添加成功' : '修改成功');
        await fetchResourcesList();
        closeResourceModal();
      } catch (error) {
        ElMessage.error(error.message || '保存失败');
      }
    };

    // 删除资源
    const handleDeleteResource = async resource => {
      if (!resource || !resource.id) return;
      try {
        await ElMessageBox.confirm(`确定要删除资源 "${resource.resourceName}" 吗？删除后无法恢复。`, '删除确认', {
          confirmButtonText: '确定删除',
          cancelButtonText: '取消',
          type: 'warning',
          confirmButtonClass: 'el-button--danger'
        });
        await deleteDataScopeResource(resource.id);
        ElMessage.success('删除成功');
        await fetchResourcesList();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error(error.message || '删除失败');
        }
      }
    };

    // 角色资源权限配置
    const roleResourcesLoading = ref(false);
    const roleResourceScopes = ref([]);

    // 部门树（用于回填已选部门名称）
    const deptTree = ref([]);

    // 获取部门树
    const fetchDeptTree = async () => {
      if (deptTree.value.length > 0) return;
      try {
        const data = await getDeptTree();
        deptTree.value = Array.isArray(data) ? data : [];
      } catch (error) {
        ElMessage.error(error.message || '获取部门树失败');
      }
    };

    // 构建部门 id → name 映射
    const buildDeptNameMap = () => {
      const map = {};
      const traverse = nodes => {
        if (!Array.isArray(nodes)) return;
        nodes.forEach(node => {
          map[node.id] = node.name;
          if (node.children && Array.isArray(node.children)) {
            traverse(node.children);
          }
        });
      };
      traverse(deptTree.value);
      return map;
    };

    // 资源数据范围变化处理
    const onResourceDataScopeChange = index => {
      const resource = roleResourceScopes.value[index];
      if (resource.dataScope !== 5) {
        // 如果不是自定义，清空部门选择
        resource.deptSelection = [];
      }
    };

    // 加载角色的资源权限配置
    const loadRoleResourceScopes = async roleId => {
      roleResourcesLoading.value = true;
      try {
        // 获取所有启用的资源
        const allResources = await getAllDataScopeResources();
        const enabledResources = Array.isArray(allResources) ? allResources.filter(r => r.status === STATUS_ENABLED) : [];

        // 如果是编辑模式，获取角色详情中的资源配置
        let roleResourceData = [];
        if (roleId) {
          try {
            const roleDetail = await getRole(roleId);
            roleResourceData = roleDetail?.resourceDataScopes || [];
          } catch (error) {
            console.error('获取角色资源配置失败:', error);
          }
        }

        // 合并资源列表和角色配置
        roleResourceScopes.value = enabledResources.map(resource => {
          const existingConfig = roleResourceData.find(r => r.resourceCode === resource.resourceCode);
          return {
            resourceCode: resource.resourceCode,
            resourceName: resource.resourceName,
            dataScope: existingConfig?.dataScope || 1,
            // 默认全部数据
            deptSelection: (existingConfig?.deptIds || []).map(id => ({
              id,
              name: ''
            }))
          };
        });

        // 如果有部门选择，加载部门树并回填部门名称
        if (roleResourceScopes.value.some(r => r.deptSelection.length > 0)) {
          await fetchDeptTree();
          const nameMap = buildDeptNameMap();
          roleResourceScopes.value.forEach(resource => {
            resource.deptSelection = resource.deptSelection.map(d => ({
              id: d.id,
              name: nameMap[d.id] || ''
            }));
          });
        }
      } catch (error) {
        ElMessage.error(error.message || '加载资源配置失败');
      } finally {
        roleResourcesLoading.value = false;
      }
    };
    onMounted(() => {
      fetchRoles();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "角色管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "统一管理角色、权限标识和数据范围配置")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": "",
          "refresh-loading": loading.value,
          onRefresh: fetchRoles
        }, {
          searchActionsLeading: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            class: "btn-primary",
            onClick: _cache[3] || (_cache[3] = $event => openModal('add'))
          }, [...(_cache[19] || (_cache[19] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 新增 ", -1)]))])), [[_directive_permission, 'system:role:add']])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleSearch
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: resetSearch
          }, "重置")]),
          actions: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            class: "btn-outline-primary",
            onClick: openPermissionConfigModal
          }, [...(_cache[20] || (_cache[20] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          })], -1), _createTextVNode(" 数据权限配置 ", -1)]))])), [[_directive_permission, 'system:role:edit']])]),
          default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchForm.name = $event),
            type: "text",
            placeholder: "角色名称",
            class: "form-input form-control-sm filter-bar-field"
          }, null, 512), [[_vModelText, searchForm.name]]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchForm.roleKey = $event),
            type: "text",
            placeholder: "权限字符",
            class: "form-input form-control-sm filter-bar-field"
          }, null, 512), [[_vModelText, searchForm.roleKey]]), _createVNode(_component_el_select, {
            modelValue: searchForm.status,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchForm.status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "启用",
              value: "0"
            }), _createVNode(_component_el_option, {
              label: "禁用",
              value: "1"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("table", _hoisted_4, [_createElementVNode("thead", _hoisted_5, [_createElementVNode("tr", null, [_createElementVNode("th", _hoisted_6, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => selectAll.value = $event),
          type: "checkbox",
          class: "form-check",
          onChange: toggleSelectAll
        }, null, 544), [[_vModelCheckbox, selectAll.value]])]), _cache[21] || (_cache[21] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "角色编号", -1)), _cache[22] || (_cache[22] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "角色名称", -1)), _cache[23] || (_cache[23] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "权限字符", -1)), _cache[24] || (_cache[24] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "数据范围", -1)), _cache[25] || (_cache[25] = _createElementVNode("th", {
          class: "data-table-th is-center"
        }, "状态", -1)), _cache[26] || (_cache[26] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "创建时间", -1)), _cache[27] || (_cache[27] = _createElementVNode("th", {
          class: "data-table-th is-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作", -1))])]), _createElementVNode("tbody", _hoisted_7, [loading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "animate-pulse"
          }, [...(_cache[28] || (_cache[28] = [_createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-4 w-4 bg-slate-200 rounded mx-auto"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-16 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-20 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-24 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-16 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-6 w-14 bg-slate-200 rounded-full mx-auto"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-24 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
          }, [_createElementVNode("div", {
            class: "flex items-center justify-center gap-1"
          }, [_createElementVNode("div", {
            class: "h-8 w-8 bg-slate-200 rounded"
          }), _createElementVNode("div", {
            class: "h-8 w-8 bg-slate-200 rounded"
          })])], -1)]))]);
        }), 64)) : _createCommentVNode("", true), !loading.value && displayedRoles.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [...(_cache[29] || (_cache[29] = [_createElementVNode("td", {
          colspan: "8",
          class: "data-table-empty"
        }, "暂无数据", -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedRoles.value, role => {
          return _openBlock(), _createElementBlock("tr", {
            key: role.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_9, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => role.selected = $event,
            type: "checkbox",
            class: "form-check"
          }, null, 8, _hoisted_10), [[_vModelCheckbox, role.selected]])]), _createElementVNode("td", _hoisted_11, _toDisplayString(role.id), 1), _createElementVNode("td", _hoisted_12, _toDisplayString(role.name), 1), _createElementVNode("td", _hoisted_13, _toDisplayString(role.roleKey), 1), _createElementVNode("td", _hoisted_14, _toDisplayString(formatDataScope(role.dataScope)), 1), _createElementVNode("td", _hoisted_15, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", role.status === STATUS_ENABLED ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'])
          }, [_createElementVNode("span", {
            class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1", role.status === STATUS_ENABLED ? 'bg-green-500' : 'bg-red-500'])
          }, null, 2), _createTextVNode(" " + _toDisplayString(role.status === STATUS_ENABLED ? '启用' : '禁用'), 1)], 2)]), _createElementVNode("td", _hoisted_16, _toDisplayString(role.createdAt || '-'), 1), _createElementVNode("td", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_withDirectives((_openBlock(), _createElementBlock("button", {
            class: "table-action-button is-primary",
            title: "修改",
            "aria-label": "修改",
            onClick: $event => openModal('edit', role)
          }, [...(_cache[30] || (_cache[30] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_19)), [[_directive_permission, 'system:role:edit']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除",
            onClick: $event => handleDeleteSingle(role)
          }, [...(_cache[31] || (_cache[31] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_20)), [[_directive_permission, 'system:role:remove']])])])]);
        }), 128))])])])]), total.value > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          current: pageNum.value,
          size: pageSize.value,
          total: total.value,
          pages: totalPage.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["current", "size", "total", "pages"])) : _createCommentVNode("", true)]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: modalVisible.value,
          size: "2xl",
          onClose: closeModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createElementVNode("h3", _hoisted_22, _toDisplayString(modalType.value === 'add' ? '新增角色' : '修改角色'), 1), _createElementVNode("button", {
            class: "p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors",
            onClick: closeModal
          }, [...(_cache[32] || (_cache[32] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("form", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", null, [_cache[33] || (_cache[33] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createElementVNode("span", {
            class: "text-red-500"
          }, "*"), _createTextVNode("角色名称 ")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.name = $event),
            type: "text",
            required: "",
            class: "form-input w-full",
            placeholder: "请输入角色名称"
          }, null, 512), [[_vModelText, form.name]])]), _createElementVNode("div", null, [_cache[34] || (_cache[34] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createElementVNode("span", {
            class: "text-red-500"
          }, "*"), _createTextVNode("权限字符 ")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.roleKey = $event),
            type: "text",
            required: "",
            class: "form-input w-full",
            placeholder: "请输入权限字符"
          }, null, 512), [[_vModelText, form.roleKey]])])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", null, [_cache[35] || (_cache[35] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createElementVNode("span", {
            class: "text-red-500"
          }, "*"), _createTextVNode("数据范围 ")], -1)), _createVNode(_component_el_select, {
            modelValue: form.dataScope,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.dataScope = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(dataScopeOptions, option => {
              return _createVNode(_component_el_option, {
                key: option.value,
                label: option.label,
                value: option.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[36] || (_cache[36] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "状态", -1)), _createVNode(_component_el_select, {
            modelValue: form.status,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.status = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "启用",
              value: STATUS_ENABLED
            }), _createVNode(_component_el_option, {
              label: "禁用",
              value: STATUS_DISABLED
            })]),
            _: 1
          }, 8, ["modelValue"])])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_27, [_cache[38] || (_cache[38] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700"
          }, "菜单权限", -1)), _createElementVNode("label", _hoisted_28, [_withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => menuCascade.value = $event),
            class: "form-check"
          }, null, 512), [[_vModelCheckbox, menuCascade.value]]), _cache[37] || (_cache[37] = _createElementVNode("span", {
            class: "text-sm text-slate-600"
          }, "父子联动", -1))])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [flattenedMenuTree.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_31, "暂无菜单数据")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flattenedMenuTree.value, item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.node.id,
              class: "flex items-center gap-2 py-1",
              style: _normalizeStyle({
                paddingLeft: `${item.level * 16}px`
              })
            }, [item.node.children && item.node.children.length > 0 ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "expand-btn p-0.5 hover:bg-slate-200 rounded transition-colors",
              onClick: $event => toggleExpand(item.node.id)
            }, [(_openBlock(), _createElementBlock("svg", {
              class: "w-4 h-4 text-slate-500 transition-transform",
              style: _normalizeStyle({
                transform: isExpanded(item.node.id) ? 'rotate(90deg)' : 'rotate(0deg)'
              }),
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [...(_cache[39] || (_cache[39] = [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 5l7 7-7 7"
            }, null, -1)]))], 4))], 8, _hoisted_32)) : (_openBlock(), _createElementBlock("span", _hoisted_33)), _createElementVNode("label", _hoisted_34, [_createElementVNode("input", {
              type: "checkbox",
              class: "form-check",
              checked: isNodeChecked(item.node),
              ".indeterminate": isNodeIndeterminate(item.node),
              onChange: $event => onNodeCheck(item.node, $event)
            }, null, 40, _hoisted_35), _createElementVNode("span", _hoisted_36, _toDisplayString(item.node.name), 1)])], 4);
          }), 128))])])]), _createElementVNode("div", null, [_cache[43] || (_cache[43] = _createElementVNode("div", {
            class: "flex items-center justify-between mb-3"
          }, [_createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700"
          }, "资源数据权限"), _createElementVNode("span", {
            class: "text-xs text-slate-500"
          }, "为不同资源配置独立的数据范围")], -1)), roleResourcesLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_37, [...(_cache[40] || (_cache[40] = [_createElementVNode("div", {
            class: "flex items-center justify-center gap-2"
          }, [_createElementVNode("svg", {
            class: "w-5 h-5 animate-spin text-primary-600",
            fill: "none",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }), _createElementVNode("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          })]), _createTextVNode(" 加载资源列表... ")], -1)]))])) : roleResourceScopes.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_38, " 暂无可配置的资源 ")) : (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("table", _hoisted_41, [_cache[42] || (_cache[42] = _createElementVNode("thead", {
            class: "bg-slate-50 sticky top-0 z-10"
          }, [_createElementVNode("tr", {
            class: "border-b border-slate-200"
          }, [_createElementVNode("th", {
            class: "px-4 py-3 text-left text-xs font-medium text-slate-700 uppercase tracking-wider whitespace-nowrap"
          }, "资源名称"), _createElementVNode("th", {
            class: "px-4 py-3 text-center text-xs font-medium text-slate-700 uppercase tracking-wider whitespace-nowrap"
          }, "全部数据"), _createElementVNode("th", {
            class: "px-4 py-3 text-center text-xs font-medium text-slate-700 uppercase tracking-wider whitespace-nowrap"
          }, "本部门"), _createElementVNode("th", {
            class: "px-4 py-3 text-center text-xs font-medium text-slate-700 uppercase tracking-wider whitespace-nowrap"
          }, "本部门及以下"), _createElementVNode("th", {
            class: "px-4 py-3 text-center text-xs font-medium text-slate-700 uppercase tracking-wider whitespace-nowrap"
          }, "仅本人"), _createElementVNode("th", {
            class: "px-4 py-3 text-center text-xs font-medium text-slate-700 uppercase tracking-wider whitespace-nowrap"
          }, "自定义")])], -1)), _createElementVNode("tbody", _hoisted_42, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleResourceScopes.value, (resource, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: resource.resourceCode
            }, [_createElementVNode("tr", _hoisted_43, [_createElementVNode("td", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createElementVNode("span", _hoisted_46, _toDisplayString(resource.resourceName), 1), _createElementVNode("span", _hoisted_47, _toDisplayString(resource.resourceCode), 1)])]), _createElementVNode("td", _hoisted_48, [_createElementVNode("label", _hoisted_49, [_withDirectives(_createElementVNode("input", {
              type: "radio",
              name: `resource-${resource.resourceCode}`,
              value: 1,
              "onUpdate:modelValue": $event => resource.dataScope = $event,
              onChange: $event => onResourceDataScopeChange(index),
              class: "form-radio"
            }, null, 40, _hoisted_50), [[_vModelRadio, resource.dataScope, void 0, {
              number: true
            }]])])]), _createElementVNode("td", _hoisted_51, [_createElementVNode("label", _hoisted_52, [_withDirectives(_createElementVNode("input", {
              type: "radio",
              name: `resource-${resource.resourceCode}`,
              value: 2,
              "onUpdate:modelValue": $event => resource.dataScope = $event,
              onChange: $event => onResourceDataScopeChange(index),
              class: "form-radio"
            }, null, 40, _hoisted_53), [[_vModelRadio, resource.dataScope, void 0, {
              number: true
            }]])])]), _createElementVNode("td", _hoisted_54, [_createElementVNode("label", _hoisted_55, [_withDirectives(_createElementVNode("input", {
              type: "radio",
              name: `resource-${resource.resourceCode}`,
              value: 3,
              "onUpdate:modelValue": $event => resource.dataScope = $event,
              onChange: $event => onResourceDataScopeChange(index),
              class: "form-radio"
            }, null, 40, _hoisted_56), [[_vModelRadio, resource.dataScope, void 0, {
              number: true
            }]])])]), _createElementVNode("td", _hoisted_57, [_createElementVNode("label", _hoisted_58, [_withDirectives(_createElementVNode("input", {
              type: "radio",
              name: `resource-${resource.resourceCode}`,
              value: 4,
              "onUpdate:modelValue": $event => resource.dataScope = $event,
              onChange: $event => onResourceDataScopeChange(index),
              class: "form-radio"
            }, null, 40, _hoisted_59), [[_vModelRadio, resource.dataScope, void 0, {
              number: true
            }]])])]), _createElementVNode("td", _hoisted_60, [_createElementVNode("label", _hoisted_61, [_withDirectives(_createElementVNode("input", {
              type: "radio",
              name: `resource-${resource.resourceCode}`,
              value: 5,
              "onUpdate:modelValue": $event => resource.dataScope = $event,
              onChange: $event => onResourceDataScopeChange(index),
              class: "form-radio"
            }, null, 40, _hoisted_62), [[_vModelRadio, resource.dataScope, void 0, {
              number: true
            }]])])])]), resource.dataScope === 5 ? (_openBlock(), _createElementBlock("tr", _hoisted_63, [_createElementVNode("td", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_cache[41] || (_cache[41] = _createElementVNode("span", {
              class: "text-sm text-slate-600 whitespace-nowrap"
            }, "选择部门：", -1)), _createVNode(DeptSelector, {
              modelValue: resource.deptSelection,
              "onUpdate:modelValue": $event => resource.deptSelection = $event,
              multiple: "",
              placeholder: "请选择部门",
              class: "flex-1"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])])])])) : _createCommentVNode("", true)], 64);
          }), 128))])])])]))])])]), _createElementVNode("div", {
            class: "flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50"
          }, [_createElementVNode("button", {
            type: "button",
            class: "px-4 py-2 border border-slate-300 text-slate-700 rounded-lg text-sm hover:bg-slate-100 transition-colors",
            onClick: closeModal
          }, " 取消 "), _createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: saveRole
          }, " 确定 ")])]),
          _: 1
        }, 8, ["visible"])])), _createVNode(AppModal, {
          visible: showDeleteModal.value,
          size: "sm",
          "panel-class": "mx-4",
          onClose: closeDeleteModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_66, [_cache[44] || (_cache[44] = _createElementVNode("div", {
            class: "w-12 h-12 mx-auto mb-4 text-red-500"
          }, [_createElementVNode("svg", {
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          })])], -1)), _cache[45] || (_cache[45] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900 mb-2"
          }, "确定要删除吗？", -1)), _createElementVNode("p", _hoisted_67, _toDisplayString(deleteHint.value), 1), _createElementVNode("div", {
            class: "flex items-center justify-center gap-3"
          }, [_createElementVNode("button", {
            onClick: closeDeleteModal,
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: confirmDelete,
            class: "btn-danger-secondary"
          }, "确定删除")])])]),
          _: 1
        }, 8, ["visible"]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: permissionConfigVisible.value,
          size: "5xl",
          onClose: closePermissionConfigModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
          }, [_cache[47] || (_cache[47] = _createElementVNode("div", null, [_createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "数据权限资源配置"), _createElementVNode("p", {
            class: "text-sm text-slate-500 mt-0.5"
          }, "配置系统中的数据权限资源及其字段映射关系")], -1)), _createElementVNode("button", {
            class: "p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors",
            onClick: closePermissionConfigModal
          }, [...(_cache[46] || (_cache[46] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_68, [_createElementVNode("div", _hoisted_69, [_createElementVNode("button", {
            class: "btn-primary",
            onClick: _cache[10] || (_cache[10] = $event => openResourceModal('add'))
          }, [...(_cache[48] || (_cache[48] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 添加资源 ", -1)]))])]), _createElementVNode("div", _hoisted_70, [_createElementVNode("table", _hoisted_71, [_cache[53] || (_cache[53] = _createElementVNode("thead", null, [_createElementVNode("tr", {
            class: "bg-slate-50 border-b border-slate-200"
          }, [_createElementVNode("th", {
            class: "px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider"
          }, "资源编码"), _createElementVNode("th", {
            class: "px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider"
          }, "资源名称"), _createElementVNode("th", {
            class: "px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider"
          }, "部门字段"), _createElementVNode("th", {
            class: "px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider"
          }, "用户字段"), _createElementVNode("th", {
            class: "px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider"
          }, "排序"), _createElementVNode("th", {
            class: "px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider"
          }, "状态"), _createElementVNode("th", {
            class: "px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider w-32"
          }, "操作")])], -1)), _createElementVNode("tbody", _hoisted_72, [resourcesLoading.value ? (_openBlock(), _createElementBlock("tr", _hoisted_73, [...(_cache[49] || (_cache[49] = [_createElementVNode("td", {
            colspan: "7",
            class: "px-4 py-8 text-center text-sm text-slate-500"
          }, [_createElementVNode("div", {
            class: "flex items-center justify-center gap-2"
          }, [_createElementVNode("svg", {
            class: "w-5 h-5 animate-spin text-primary-600",
            fill: "none",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }), _createElementVNode("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          })]), _createTextVNode(" 加载中... ")])], -1)]))])) : resourcesList.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_74, [...(_cache[50] || (_cache[50] = [_createElementVNode("td", {
            colspan: "7",
            class: "px-4 py-8 text-center text-sm text-slate-500"
          }, "暂无数据权限资源配置", -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resourcesList.value, resource => {
            return _openBlock(), _createElementBlock("tr", {
              key: resource.id,
              class: "hover:bg-slate-50 cursor-pointer transition-colors"
            }, [_createElementVNode("td", _hoisted_75, _toDisplayString(resource.resourceCode), 1), _createElementVNode("td", _hoisted_76, _toDisplayString(resource.resourceName), 1), _createElementVNode("td", _hoisted_77, _toDisplayString(resource.deptColumn || '-'), 1), _createElementVNode("td", _hoisted_78, _toDisplayString(resource.userColumn || '-'), 1), _createElementVNode("td", _hoisted_79, _toDisplayString(resource.sort || 0), 1), _createElementVNode("td", _hoisted_80, [_createElementVNode("span", {
              class: _normalizeClass(["status-badge", resource.status === STATUS_ENABLED ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'])
            }, [_createElementVNode("span", {
              class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1", resource.status === STATUS_ENABLED ? 'bg-green-500' : 'bg-red-500'])
            }, null, 2), _createTextVNode(" " + _toDisplayString(resource.status === STATUS_ENABLED ? '启用' : '禁用'), 1)], 2)]), _createElementVNode("td", _hoisted_81, [_createElementVNode("div", _hoisted_82, [_createElementVNode("button", {
              class: "table-action-button is-primary",
              title: "编辑",
              "aria-label": "编辑",
              onClick: $event => openResourceModal('edit', resource)
            }, [...(_cache[51] || (_cache[51] = [_createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
            })], -1)]))], 8, _hoisted_83), _createElementVNode("button", {
              class: "table-action-button is-danger",
              title: "删除",
              "aria-label": "删除",
              onClick: $event => handleDeleteResource(resource)
            }, [...(_cache[52] || (_cache[52] = [_createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            })], -1)]))], 8, _hoisted_84)])])]);
          }), 128))])])])]), _createElementVNode("div", {
            class: "flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50"
          }, [_createElementVNode("button", {
            type: "button",
            class: "px-4 py-2 border border-slate-300 text-slate-700 rounded-lg text-sm hover:bg-slate-100 transition-colors",
            onClick: closePermissionConfigModal
          }, " 关闭 ")])]),
          _: 1
        }, 8, ["visible"])])), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: resourceModalVisible.value,
          size: "2xl",
          "z-index": 60,
          onClose: closeResourceModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_85, [_createElementVNode("h3", _hoisted_86, _toDisplayString(resourceModalType.value === 'add' ? '添加资源' : '编辑资源'), 1), _createElementVNode("button", {
            class: "p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors",
            onClick: closeResourceModal
          }, [...(_cache[54] || (_cache[54] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_87, [_createElementVNode("form", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_createElementVNode("div", null, [_cache[55] || (_cache[55] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createElementVNode("span", {
            class: "text-red-500"
          }, "*"), _createTextVNode("资源编码 ")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => resourceForm.resourceCode = $event),
            type: "text",
            required: "",
            class: "form-input w-full font-mono",
            placeholder: "例如: customer"
          }, null, 512), [[_vModelText, resourceForm.resourceCode]])]), _createElementVNode("div", null, [_cache[56] || (_cache[56] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createElementVNode("span", {
            class: "text-red-500"
          }, "*"), _createTextVNode("资源名称 ")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => resourceForm.resourceName = $event),
            type: "text",
            required: "",
            class: "form-input w-full",
            placeholder: "例如: 客户"
          }, null, 512), [[_vModelText, resourceForm.resourceName]])])]), _createElementVNode("div", _hoisted_90, [_createElementVNode("div", null, [_cache[57] || (_cache[57] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, " 部门字段名 ", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => resourceForm.deptColumn = $event),
            type: "text",
            class: "form-input w-full font-mono",
            placeholder: "例如: owner_dept_id"
          }, null, 512), [[_vModelText, resourceForm.deptColumn]]), _cache[58] || (_cache[58] = _createElementVNode("p", {
            class: "text-xs text-slate-500 mt-1"
          }, "数据库中关联部门的字段名", -1))]), _createElementVNode("div", null, [_cache[59] || (_cache[59] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, " 用户字段名 ", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => resourceForm.userColumn = $event),
            type: "text",
            class: "form-input w-full font-mono",
            placeholder: "例如: owner_user_id"
          }, null, 512), [[_vModelText, resourceForm.userColumn]]), _cache[60] || (_cache[60] = _createElementVNode("p", {
            class: "text-xs text-slate-500 mt-1"
          }, "数据库中关联用户的字段名", -1))])]), _createElementVNode("div", _hoisted_91, [_createElementVNode("div", null, [_cache[61] || (_cache[61] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "排序号", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => resourceForm.sort = $event),
            type: "number",
            class: "form-input w-full",
            placeholder: "0"
          }, null, 512), [[_vModelText, resourceForm.sort, void 0, {
            number: true
          }]])]), _createElementVNode("div", null, [_cache[62] || (_cache[62] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "状态", -1)), _createVNode(_component_el_select, {
            modelValue: resourceForm.status,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => resourceForm.status = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "启用",
              value: STATUS_ENABLED
            }), _createVNode(_component_el_option, {
              label: "禁用",
              value: STATUS_DISABLED
            })]),
            _: 1
          }, 8, ["modelValue"])])]), _createElementVNode("div", null, [_cache[63] || (_cache[63] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "资源描述", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => resourceForm.description = $event),
            rows: "3",
            class: "form-textarea",
            placeholder: "请输入资源描述（可选）"
          }, null, 512), [[_vModelText, resourceForm.description]])])])]), _createElementVNode("div", {
            class: "flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50"
          }, [_createElementVNode("button", {
            type: "button",
            class: "px-4 py-2 border border-slate-300 text-slate-700 rounded-lg text-sm hover:bg-slate-100 transition-colors",
            onClick: closeResourceModal
          }, " 取消 "), _createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: saveResource
          }, " 确定 ")])]),
          _: 1
        }, 8, ["visible"])]))]),
        _: 1
      });
    };
  }
};